import moment from 'moment-timezone';
import dayjs from 'dayjs';
import momentz from 'moment';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);

/**
 *
 * @param {array} a
 * @param {array} b
 * @param {*} orderBy
 * @returns comparition of two array
 * used for table sorting dynamic
 */
export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

/**
 *
 * @param {*} order
 * @param {*} orderBy
 * @returns sorted list of array by give order
 */
export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

/**
 *
 * @param {array} array
 * @param {*} comparator
 * @returns sort given array through comparator
 */
export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {

    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function getFilteredBy(rows, filterBy) {
  const filterKeys = Object.keys(filterBy);

  let frows = rows.filter((item) => {
    // validates all filter criteria
    return filterKeys.every((key) => {
      if (filterBy[key] !== '') {
        if (key === 'name') {
          return String(item[key])
            .toLowerCase()
            .includes(String(filterBy[key]).toLowerCase());
        } else if (
          [
            'dateOfRequest',
            'created_time',
            'updatedAt',
            'lastupdated',
            'lastupdatedtime',
            'createdOn',
          ].includes(key)
        ) {
          if (filterBy[key].start !== '' && filterBy[key].end !== '') {
            const date = moment(item[key]).format('YYYY-MM-DD');
            const start = moment(filterBy[key].start).format('YYYY-MM-DD');
            const end = moment(filterBy[key].end).format('YYYY-MM-DD');
            if (filterBy[key].start === filterBy[key].end) {
              return date > start && date < end;
            } else {
              return date >= start && date <= end;
            }
          } else {
            return true;
          }
        } else {
          return (
            String(filterBy[key]).toLowerCase() ===
            String(item[key]).toLowerCase()
          );
        }
      } else {
        return true;
      }
    });
  });

  return frows;
}

/**
 *
 * @returns Random Number
 */
export function getRandomNumber() {
  const min = 1;
  const max = 100;
  const rand = min + Math.random() * (max - min);
  return rand;
}

/**
 *
 * @param {string} str
 * @returns unique string id (prefix given str)
 */
export function getuniqueId(str) {
  var uniq = (str ? str : '') + new Date().getTime();
  return uniq;
}

/**
 *
 * @param {String} url
 * @param {String} key
 * @returns value of parameter from url
 */
export function getParamsFromUrl(url, key) {
  const queryString = url;
  const urlParams = new URLSearchParams(queryString);
  let val = urlParams.get(key);
  return val ? val : false;
}

/**
 * Generate password for new registred users
 * @returns password string
 */
export function generateP() {
  var pass = '';
  var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$';
  for (var i = 1; i <= 10; i++) {
    var char = Math.floor(Math.random() * str.length + 1);

    pass += str.charAt(char);
  }

  return pass;
}

/**
 *
 * @param {datetime} startTime
 * @param {datetime} endTime
 * @returns duration bitween two date times
 */
export function getDuration(startTime, endTime) {
  if (startTime && endTime) {
    // start time and end time
    var startTimeA = moment(startTime, 'HH:mm:ss a');
    //console.log(startTime);
    var endTimeA;
    if (startTime.slice(-2) === 'AM') {
      endTimeA = moment(endTime, 'HH:mm:ss a');
    } else {
      endTimeA = moment(endTime, 'HH:mm:ss a').add(1, 'd');
    }

    //console.log(startTime.slice(-2));

    // calculate total duration
    var duration = moment.duration(endTimeA.diff(startTimeA));

    // duration in hours
    var hours = parseInt(duration.asHours());

    // duration in minutes
    var minutes = parseInt(duration.asMinutes()) % 60;

    return hours + ':' + minutes;
  }
  return '';
}

export function getDurationDiff(startTime, endTime) {
  if (startTime && endTime) {
    // start time and end time
    var startTimeA = moment(startTime, 'HH:mm:ss a');
    var endTimeA;
    if (startTime.slice(-2) === 'AM') {
      endTimeA = moment(endTime, 'HH:mm:ss a');
    } else {
      endTimeA = moment(endTime, 'HH:mm:ss a').add(1, 'd');
    }
    // calculate total duration
    var duration = moment.duration(endTimeA.diff(startTimeA));

    // duration in hours
    var hours = parseInt(duration.asHours());

    // duration in minutes
    //var minutes = parseInt(duration.asMinutes()) % 60;
    if (hours <= 20) {
      return true;
    } else {
      return false;
    }
  }
  return '';
}

export function minTwoDigits(n) {
  if (n >= 0) return (n < 10 ? '0' : '') + n;
  else return n;
}

/**
 *
 * @param {datetime} startTime
 * @returns formated time
 */
export function getTimeFormat(startTime) {
  const today = moment.utc();
  const [hour, minute] = startTime.split(':');
  let sdate = moment(today).set('hours', hour).set('minute', minute);

  return moment(sdate).format('hh:mm A');
}
export function splitTimeValues(time) {
  if (time) {
    const [hourminute, p] = time.split(' ');
    const [hour, minute] = hourminute.split(':');
    return { hour, minute, p };
  }
  return {};
}
export function groupByKey(array, key) {
  return array.reduce((hash, obj) => {
    if (obj[key] === undefined) return hash;
    return Object.assign(hash, {
      [obj[key]]: (hash[obj[key]] || []).concat(obj),
    });
  }, {});
}

export function groupByKeyDate(array, key) {
  return array.reduce((hash, obj) => {
    if (obj[key] === undefined) return hash;
    return Object.assign(hash, {
      [moment(Number(obj[key])).format('MMMM D, YYYY')]: (
        hash[moment(Number(obj[key])).format('MMMM D, YYYY')] || []
      ).concat(obj),
    });
  }, {});
}

export function chagedtime(time) {
  const fireBaseTime = moment(
    time?.seconds * 1000 + time?.nanoseconds / 1000000
  );
  //console.log(fireBaseTime);
  const timeno = moment(fireBaseTime);
  const nowtime = moment.tz(timeno, 'America/New_York').format();
  // const nowtimen = moment(nowtime);
  //console.log(nowtime);
  var duration = ` ${moment(nowtime).format('MMM DD, YY')} ${'\n'} ${moment(
    nowtime
  ).format('hh:mm:ss')}`;

  //var formatted = duration.format("hh:mm:ss");
  return duration;
}
export function getFormatedDate(timestamp) {
  return timestamp
    ? moment(Number(timestamp))?.format('MMMM D, YYYY')
    : timestamp;
}
export function FormatedDates(timestamp) {
  return timestamp
    ? moment(Number(timestamp)).format('MMM D, YYYY')
    : timestamp;
}
export function getFormatedTime(timestamp, userTimezone) {
  if (!timestamp) return null;
  return moment(Number(timestamp))
    ?.tz(userTimezone)
    ?.format('hh:mm:ss A');
}

export function getTimeZoneDate(timestamp, userTimezone) {
  if (!timestamp) return null;
  return moment(Number(timestamp))
    ?.tz(userTimezone)
    ?.format('MMM D, YYYY');
}
/**
 *
 * @param {array} myArray
 * @returns unique array
 */
export function getUniqueArray(myArray) {
  return myArray.filter((v, i, a) => a.indexOf(v) === i);
}


export function formatDate(timestamp) {
  const date = timestamp ? new Date(timestamp.seconds * 1000) : null;
  return date ? moment(date).format("MMM DD, YYYY") : "---";
};

export function convertFirestoreTimestampToDate(timestamp) {
  if (!timestamp) {
    return null;
  }
  return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
};

export function datetimest() {
  try {
    const now = new Date();

    const utcTime = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds(),
      now.getUTCMilliseconds()
    );

    return utcTime;
  } catch (error) {
    return null;
  }
}
export function cleanMessage(message) {
  return message.replace(/\s+/g, ' ').trim();
};

export function generateTimes(timeInterval = 30) {
  const times = [];

  for (let hour = 8; hour < 24; hour++) {
      for (let min = 0; min < 60; min += timeInterval) {
          const suffix = hour < 12 ? 'am' : 'pm';
          const hourIn12 = hour % 12 === 0 ? 12 : hour % 12;
          const formattedHour = hourIn12.toString().padStart(2, '0');
          const formattedMin = min.toString().padStart(2, '0');
          times.push(`${formattedHour}:${formattedMin} ${suffix}`);
      }
  }

  for (let hour = 0; hour < 8; hour++) {
      for (let min = 0; min < 60; min += timeInterval) {
          const suffix = 'am';
          const hourIn12 = hour % 12 === 0 ? 12 : hour % 12;
          const formattedHour = hourIn12.toString().padStart(2, '0');
          const formattedMin = min.toString().padStart(2, '0');
          times.push(`${formattedHour}:${formattedMin} ${suffix}`);
      }
  }

  return times;
}

export function timeToMinutes (timeStr) {
  if (!timeStr || typeof timeStr !== 'string') {
    return null;
}
  const [time, period] = timeStr.split(' ');
  const [hours, minutes] = time.split(':').map(Number);
  const isPM = period === 'pm' && hours !== 12;
  const isMidnight = period === 'am' && hours === 12;
  const totalMinutes = (isMidnight ? 0 : (isPM ? (hours + 12) : hours)) * 60 + minutes;
  return totalMinutes;
};

// Helper function to get the ordinal suffix for a date
function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return "th"; // Handles 11th, 12th, 13th, etc.
  switch (day % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}

const schedulingOptions = [
  "Daily",
];

const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export function generateOptionsList(selectedDate) {
  if (!selectedDate) {
    return [];
  }

  const dayIndex = selectedDate.$W;
  const dayOfWeek = daysOfWeek[dayIndex];
  const dayOfMonth = selectedDate.$D;

  // Determine the week of the month
  const weekOfMonth = Math.ceil(dayOfMonth / 7);
  const weekNames = ["First", "Second", "Third", "Fourth", "Fifth"];
  const weekName = weekNames[weekOfMonth - 1] || "Fifth";

  const optionsList = [];

  optionsList.push({
    label: `Every ${dayOfWeek}`,
    value: `every_${dayOfWeek.toLowerCase()}`,
  });

  optionsList.push({
    label: `Every Other ${dayOfWeek}`,
    value: `every_other_${dayOfWeek.toLowerCase()}`,
  });

  optionsList.push({
    label: `Every Third ${dayOfWeek}`,
    value: `every_third_${dayOfWeek.toLowerCase()}`,
  });

  optionsList.push({
    label: `Every Fourth ${dayOfWeek}`,
    value: `every_fourth_${dayOfWeek.toLowerCase()}`,
  });

  optionsList.push({
    label: `The ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)} of Every Month`,
    value: `the_${dayOfMonth}_of_every_month`,
  });

  optionsList.push({
    label: `The ${weekName} ${dayOfWeek} of Every Month`,
    value: `the_${weekName.toLowerCase()}_${dayOfWeek.toLowerCase()}_of_every_month`,
  });

  schedulingOptions.forEach(option => {
    optionsList.push({
      label: option,
      value: option.toLowerCase().replace(/ /g, "_"),
    });
  });

  return optionsList;
}

export const numberOptions = Array.from({ length: 29 }, (_, i) => ({
  label: (i + 2).toString(),
  value: i + 2,
}));

export function calculateDurationInMinutes(startTime, endTime) {
  let start = moment(startTime, "hh:mm A");
  let end = moment(endTime, "hh:mm A");

  if (end.isBefore(start)) {
    end.add(1, 'day');
  }

  return end.diff(start, 'minutes');
}

export function generateAppointmentTypeId () {
  return Math.floor(Math.random() * 100000000);
};


export function generateUniqueId () {
  return Math.floor(Math.random() * 10000000000);
};

// export function formatSelectedDateTime(selectedDate, startTime) {
//   const momentSelectedDate = moment(selectedDate).startOf('day');
//   const momentStartTime = moment(startTime, 'hh:mm A');

//   const combinedDateTime = momentSelectedDate.set({
//     hour: momentStartTime.hour(),
//     minute: momentStartTime.minute(),
//     second: 0,
//   });

//   return combinedDateTime.format('YYYY-MM-DDTHH:mm:ssZ');
// }

function getTimezoneOffset(timeZone) {
  if(!timeZone){
    return null;
  }
  const str = new Date().toLocaleString('en', { timeZone, timeZoneName: 'longOffset' });
  const [, h, m] = str.match(/([+-]\d+):(\d+)$/) || [, '+00', '00'];
  return h * 60 + (h > 0 ? +m : -m);
}

const formatOffset = (offsetMinutes) => {
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absOffset = Math.abs(offsetMinutes);
  const hours = Math.floor(absOffset / 60).toString().padStart(2, '0');
  const minutes = (absOffset % 60).toString().padStart(2, '0');
  return `${sign}${hours}:${minutes}`;
};


export function formatSelectedDateTime(selectedDate, startTime, timezone) {
  if (!selectedDate || !startTime) {
      return null;
  }

  let momentSelectedDate;

  if (dayjs.isDayjs(selectedDate)) {
    momentSelectedDate = moment(selectedDate.toDate());
  } else if (selectedDate instanceof Date) {
    momentSelectedDate = moment(selectedDate);
  } else {
    momentSelectedDate = moment(selectedDate, ['MM/DD/YYYY', 'MM-DD-YYYY', 'DD/MM/YYYY', 'DD-MM-YYYY'], true);
    if (!momentSelectedDate.isValid()) {
      console.error("Invalid date format. Please use DD/MM/YYYY, DD-MM-YYYY, MM-DD-YYYY, or MM/DD/YYYY.");
    }
  }

  const momentStartTime = moment(startTime, 'hh:mm A');


  if (!momentStartTime.isValid()) {
    console.error("Invalid time format. Please use hh:mm AM/PM format.");
  }

  const combinedDateTime = momentSelectedDate.set({
    hour: momentStartTime.hour(),
    minute: momentStartTime.minute(),
    second: 0,
  });

  const timeZoneOffset = getTimezoneOffset(timezone);
  const formatedOffset = formatOffset(timeZoneOffset);
  return `${combinedDateTime.format('YYYY-MM-DDTHH:mm:ss')}${formatedOffset}`;
}

export function ValidDate(dateString) {
  if (!dateString) {
    return null;
  }
  const regex = /^(0[1-9]|[12][0-9]|3[01])[\/-](0[1-9]|1[0-2])[\/-](\d{4})$/;

  if (!dateString.match(regex)) return false;

  const [day, month, year] = dateString.split(/[\/-]/).map(Number);

  const date = new Date(year, month - 1, day);

  const isValidDate =
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day;

  return isValidDate;
}
// export function ValidTime (timeString) {
//   const regex = /^(0?[1-9]|1[0-2]):([0-5][0-9]\s?[APap][mM])$/;

//   return regex.test(timeString);
// };
export function formatTime(timeString) {
  if (!timeString) return "Invalid time";
  const trimmedTime = timeString?.trim();

  const isCorrectFormat = moment(trimmedTime, "hh:mm a", true).isValid();
  if (isCorrectFormat) {
    return trimmedTime.toLowerCase();
  }

  const parsedTime = moment(trimmedTime, ["h:mm a", "h a", "hhmma", "hhmm a", "hmm a", "hmm", "ha"], true);
  if (parsedTime.isValid()) {
    return parsedTime.format("hh:mm a").toLowerCase();
  }

  const fallbackTime = moment(trimmedTime, ["h", "hh", "hmm", "hhmm"], true);
  if (fallbackTime.isValid()) {
    return fallbackTime.format("hh:mm a").toLowerCase();
  }

  const parsed24HourTime = moment(trimmedTime, ["HH:mm", "H:mm"], true);
  if (parsed24HourTime.isValid()) {
    return parsed24HourTime.format("hh:mm a").toLowerCase();
  }

  if (/^\d{1,2}$/.test(trimmedTime)) {
    const minutes = parseInt(trimmedTime, 10);
    if (minutes < 60) {
      return moment({ hour: 0, minute: minutes }).format("hh:mm a").toLowerCase();
    }
  }
  return "Invalid time";
}

export function isTimeInRange(time, startTime = "9:00 am", endTime = "5:00 pm", standardWorkTime = "no", updatedStartTime, newStartTime) {
 
  if (!time || time?.trim() === "") {
    return { isValid: false, error: "Time is required." };
  }

  const allowedFormats = [
    "hh:mm a", "h:mm a", "h a", "hhmma", "hhmm a", "hmm a", "hmm", "ha", 
    "h", "hh", "hmm", "hhmm", "HH:mm", "H:mm"
  ];

  let trimmedTime = time.toString().trim().toLowerCase();

  if (/^\d{3,4}[apm]{2}$/.test(trimmedTime)) {
    const match = trimmedTime.match(/^(\d{1,2})(\d{2})?([apm]{2})$/);
    if (match) {
      let hours = match[1];
      let minutes = match[2] || "00";
      let period = match[3];
      trimmedTime = `${hours}:${minutes} ${period}`;
    }
  }

  if (/^\d{1,2}$/.test(trimmedTime)) {
    const num = parseInt(trimmedTime, 10);
    if (num >= 1 && num <= 12) {
      trimmedTime = `${num} am`;
    } else if (num > 12 && num <= 23) {
      trimmedTime = `${num}:00`;
    } else {
      return { isValid: false, error: "Invalid time format." }; 
    }
  }

  const start = moment(startTime, allowedFormats, true);
  const end = moment(endTime, allowedFormats, true);
  const checkTime = moment(trimmedTime, allowedFormats, true);

  if (!checkTime.isValid()) {
    return { isValid: false, error: "Invalid time format." };
  }

  standardWorkTime = standardWorkTime ?? "no";

  if (standardWorkTime === "yes" && updatedStartTime) {
    return { isValid: true, error: null };
  }

  if (standardWorkTime === "yes" && !updatedStartTime) {
    const newStart = moment(newStartTime, allowedFormats, true);
    if (checkTime.isBefore(newStart)) {
      if (newStart.hour() >= 12 && checkTime.hour() < 12) {
        return { isValid: true, error: null };
      } else {
        return { isValid: false, error: "End time cannot be before start time." };
      }
    }
  }

  if (standardWorkTime === "no") {
    if (checkTime.isSameOrAfter(start) && checkTime.isSameOrBefore(end)) {
      return { isValid: true, error: null };
    } else {
      return { isValid: false, error: "Time is out of range." };
    }
  }
  return { isValid: true, error: null };
}

export function ValidTime(timeString) {
  if (!timeString || typeof timeString !== "string") return false;

  let trimmedTime = timeString.trim().toLowerCase();

  const allowedFormats = [
    "hh:mm a", "h:mm a", "h a", "hhmma", "hhmm a", "hmm a", "hmm", "ha", 
    "h", "hh", "hmm", "hhmm", "HH:mm", "H:mm"
  ];

  if (/^\d{3,4}[apm]{2}$/.test(trimmedTime)) {
    const match = trimmedTime.match(/^(\d{1,2})(\d{2})?([apm]{2})$/);
    if (match) {
      let hours = match[1];
      let minutes = match[2] || "00";
      let period = match[3];
      trimmedTime = `${hours}:${minutes} ${period}`;
    }
  }

  if (/^\d{1,2}$/.test(trimmedTime)) {
    const num = parseInt(trimmedTime, 10);
    if (num >= 1 && num <= 12) {
      trimmedTime = `${num} am`;
    } else if (num > 12 && num <= 23) {
      trimmedTime = `${num}:00`;
    } else {
      return false;
    }
  }

  return moment(trimmedTime, allowedFormats, true).isValid();
}

export function disableTimeSlots(timeSlots, startTime, endTime, standardWorkTime, newEndTime, startTimes) {
  const start = moment(startTime, 'hh:mm a');
  const end = moment(endTime, 'hh:mm a');
  const NewStart = moment(timeSlots, 'hh:mm a');
  const originalStart = moment(startTimes, 'hh:mm a');
  const eightAM = moment('08:00 am', 'hh:mm a');

  if (standardWorkTime === "yes") {
    return timeSlots.map(slot => {
      const slotTime = moment(slot, 'hh:mm a');
      const isNextDay = newEndTime && slotTime.isBefore(NewStart);
      let isDisabled;

      if (newEndTime === true) {
        isDisabled = slotTime.isBetween(eightAM, originalStart, undefined, '[]');
      } else {
        isDisabled = slotTime.isSameOrBefore(start) || slotTime.isAfter(end);
      }
      return {
        time: slot,
        disabled: isDisabled,
        nextDay: isNextDay,
      }
    });
  }


  return timeSlots.map(slot => {
    const slotTime = moment(slot, 'hh:mm a');
    const isNextDay = newEndTime && slotTime.isBefore(NewStart);
    let isDisabled;

    if (newEndTime === true) {
      isDisabled = slotTime.isBetween(eightAM, originalStart, undefined, '[]');
    } else {
      isDisabled = slotTime.isSameOrBefore(start) || slotTime.isAfter(end);
    }

    return {
      time: slot,
      disabled: isDisabled,
      nextDay: isNextDay,
    };
  });
}

export function getUpcomingDates(startDate, frequency, numberOfTimes, allowedDays) {
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const results = [];
  const start = new Date(startDate);

  if (isNaN(start.getTime())) {
    console.error("Invalid start date format. Please use a valid date format (e.g., October 24, 2024).");
  }

  const frequencyParts = frequency?.split('_');
  const baseFrequency = frequencyParts?.slice(0, -1).join('_');
  const frequencyInterval = getFrequencyInterval(baseFrequency);
  const dayName = frequencyParts[frequencyParts.length - 1];
  const dayIndex = getDayIndex(dayName, daysOfWeek);

const allowedDayIndexes = allowedDays
  ? allowedDays?.map(day => daysOfWeek.indexOf(day.charAt(0).toUpperCase() + day.slice(1).toLowerCase()))
  : [0, 1, 2, 3, 4, 5, 6];

  if (isSpecificDayOfMonth(frequencyParts)) {
    handleSpecificDayOfMonth(frequencyParts, start, results, numberOfTimes);
  } else if (isWeekSpecific(frequencyParts)) {
    handleWeekSpecific(frequencyParts, start, results, numberOfTimes, daysOfWeek);
  } else if (frequency === 'daily') {
    handleDaily(start, results, numberOfTimes, allowedDayIndexes);
  } else if (dayIndex !== -1) {
    handleRegularFrequency(start, dayIndex, frequencyInterval, results, numberOfTimes, allowedDayIndexes);
  } else {
    handleWeeklyIntervals(start, frequencyInterval, results, numberOfTimes, allowedDayIndexes);
  }

  return results;
}

function getFrequencyInterval(baseFrequency) {
  const frequencyMap = {
    every: 1,
    every_other: 2,
    daily: 1,
    every_third: 3,
    every_fourth: 4,
  };
  return frequencyMap[baseFrequency] || 1;
}

function getDayIndex(dayName, daysOfWeek) {
  if (!dayName) return -1;
  return daysOfWeek.indexOf(dayName.charAt(0).toUpperCase() + dayName.slice(1));
}

function isSpecificDayOfMonth(frequencyParts) {
  return frequencyParts.length === 5 && frequencyParts[0] === 'the';
}

function handleSpecificDayOfMonth(frequencyParts, start, results, numberOfTimes) {
  const dayOfMonth = parseInt(frequencyParts[1]);
  if (dayOfMonth < 1 || dayOfMonth > 31) {
    console.error('Invalid day of month in frequency.');
  }

  let currentYear = start.getFullYear();
  let currentMonth = start.getMonth();

  while (results.length < numberOfTimes) {
    let targetDate = new Date(currentYear, currentMonth, dayOfMonth);
    if (targetDate.getMonth() !== currentMonth) {
      targetDate = new Date(currentYear, currentMonth + 1, 0);
    }

    if (targetDate >= start) {
      results?.push(formatLeapYear(targetDate));
    }

    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
  }
}

function isWeekSpecific(frequencyParts) {
  return frequencyParts.length === 6 && frequencyParts[0] === 'the';
}

function handleWeekSpecific(frequencyParts, start, results, numberOfTimes, daysOfWeek) {
  const weekMap = { first: 1, second: 2, third: 3, fourth: 4, fifth: 5 };
  const targetWeek = weekMap[frequencyParts[1]?.toLowerCase()];
  const targetDay = frequencyParts[2].toLowerCase();
  const targetDayIndex = getDayIndex(targetDay, daysOfWeek);

  let currentYear = start.getFullYear();
  let currentMonth = start.getMonth();

  while (results?.length < numberOfTimes) {
    const firstOfMonth = new Date(currentYear, currentMonth, 1);
    const firstDayOfWeek = firstOfMonth.getDay();
    let dayOfMonth = 1 + ((targetDayIndex - firstDayOfWeek + 7) % 7) + (targetWeek - 1) * 7;

    if (dayOfMonth > new Date(currentYear, currentMonth + 1, 0).getDate()) {
      dayOfMonth -= 7;
    }

    const targetDate = new Date(currentYear, currentMonth, dayOfMonth);
    if (targetDate >= start) {
      results?.push(formatLeapYear(targetDate));
    }

    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
  }
}

function handleDaily(start, results, numberOfTimes, allowedDayIndexes) {
  let currentDate = new Date(start);
  while (results.length < numberOfTimes) {
    if (allowedDayIndexes?.includes(currentDate.getDay())) {
      results?.push(formatLeapYear(currentDate));
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }
}

function handleRegularFrequency(start, dayIndex, frequencyInterval, results, numberOfTimes, allowedDayIndexes) {
  let currentDate = new Date(start);
  currentDate.setDate(currentDate.getDate() + ((dayIndex + 7 - currentDate.getDay()) % 7));

  while (results.length < numberOfTimes) {
    if (allowedDayIndexes?.includes(currentDate.getDay())) {
      results.push(formatLeapYear(currentDate));
    }
    currentDate.setDate(currentDate.getDate() + 7 * frequencyInterval);
  }
}

function handleWeeklyIntervals(start, frequencyInterval, results, numberOfTimes, allowedDayIndexes) {
  let currentDate = new Date(start);

  while (results.length < numberOfTimes) {
    if (allowedDayIndexes?.includes(currentDate.getDay())) {
      results.push(formatLeapYear(currentDate));
    }
    currentDate.setDate(currentDate.getDate() + 7 * frequencyInterval);
  }
}

function formatLeapYear(date) {
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }
  return date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

const formats = ['YYYY-MM-DD h:mm A', 'YYYY-MM-DD h:mm a', 'YYYY-MM-DD hh:mm A', 'YYYY-MM-DD hh:mm a'];

export function filterAppointmentsOnSameDate(appointments, selectedClientId, targetDate, startTime, endTime, employeeId) {
  if (!appointments) {
    return [];
  }

  const targetDateFormatted = dayjs(targetDate).startOf('day');
    const filteredAppointments = appointments?.filter(appointment => {
    const apptDetails = appointment?.apoointmentDetails;
    if (!apptDetails?.date || !apptDetails?.time || !apptDetails?.endTime) return false;

    const appointmentDateFormatted = dayjs(apptDetails?.date).startOf('day');
    const isSameDate = appointmentDateFormatted.isSame(targetDateFormatted, 'day');

    if (!isSameDate) return false;

    const isMatchingClient = apptDetails?.clientId === selectedClientId || appointment?.clientId === selectedClientId;
    const isMatchingEmployee = apptDetails?.userId === employeeId || appointment?.userId === employeeId;

    // if (!isSameDate || !isMatchingClient || !isMatchingEmployee) return false;
    const hasConflictPotential = isMatchingClient || isMatchingEmployee;
    if (!hasConflictPotential) return false;

    const baseDate = dayjs(targetDate).format('YYYY-MM-DD');

    let existingStart = dayjs(`${baseDate} ${apptDetails?.time}`, formats, true);
    let existingEnd = dayjs(`${baseDate} ${apptDetails?.endTime}`, formats, true);
    let newStart = dayjs(`${baseDate} ${startTime}`, formats, true);
    let newEnd = dayjs(`${baseDate} ${endTime}`, formats, true);

     // Fallback to loose parsing if strict fails (Safari-safe)
    if (!existingStart.isValid()) existingStart = dayjs(`${baseDate} ${apptDetails?.time}`);
    if (!existingEnd.isValid()) existingEnd = dayjs(`${baseDate} ${apptDetails?.endTime}`);
    if (!newStart.isValid()) newStart = dayjs(`${baseDate} ${startTime}`);
    if (!newEnd.isValid()) newEnd = dayjs(`${baseDate} ${endTime}`);

    if (existingEnd.isSameOrBefore(existingStart)) {
      existingEnd = existingEnd.add(1, 'day');
    }

    if (newEnd.isSameOrBefore(newStart)) {
      newEnd = newEnd.add(1, 'day');
    }

    if (!existingStart.isValid() || !existingEnd.isValid() || !newStart.isValid() || !newEnd.isValid()) {
      return false;
    }

    const isOverlap = newStart.isBefore(existingEnd) && newEnd.isAfter(existingStart);
    // const isOverlap = (newStart.isAfter(existingStart) && newStart.isBefore(existingEnd)) || (newEnd.isAfter(existingStart) && newEnd.isBefore(existingEnd)) 
    //  || (existingStart.isAfter(newStart) && existingStart.isBefore(newEnd)) || (existingEnd.isAfter(newStart) && existingEnd.isBefore(newEnd));
    return isOverlap;
  });

  if (filteredAppointments?.length > 0) {
    return filteredAppointments?.map(appointment => ({
      ...appointment,
      id: appointment.id,
      date: appointment.apoointmentDetails.date,
      time: appointment.apoointmentDetails.time,
      endTime: appointment.apoointmentDetails.endTime,
    }));
  }

  return [];
}

export function filterAppointments (appointments, clientName, empNames) {
  return appointments.filter((item) => {
    if (clientName === "All") {
      if (empNames === "All" || empNames === "Inactive Employee") {
        return true;
      }
      return item?.userId === empNames;
    }  
    if (empNames === "All" || empNames === "Inactive Employee") {
      return item?.clientId === clientName;
    }
    return item?.clientId === clientName && item?.userId === empNames;
  });
};


export function generateNumberArray(start = 1, end = 30) {
  if (start > end) {
      console.error("Start number must be less than or equal to the end number.");
  }
  return Array.from({ length: end - start + 1 }, (_, i) => i + start);
}

export function formDateCustom(timestamp) {
  let time;

  if (typeof timestamp === "object" && timestamp?.seconds) {
    time = momentz.unix(timestamp.seconds);
  } else {
    time = momentz(timestamp);
  }

  const now = momentz();
  const diffInSeconds = now.diff(time, "seconds");
  const diffInMinutes = now.diff(time, "minutes");
  const diffInHours = now.diff(time, "hours");
  const diffInDays = now.diff(time, "days");

  if (diffInSeconds < 60) {
    return "Just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
  } else if (diffInHours <= 6) {
    return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
  } else if (now.isSame(time, "day")) {
    return "Today";
  } else if (diffInDays === 1) {
    return "Yesterday";
  } else {
    return time?.format("MM/DD h:mma");
  }
}

export function generateFirebaseId(categoryIds) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  const generateId = () => {
    let id = '';
    for (let i = 0; i < 20; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  let id = generateId();

  while (categoryIds.includes(id)) {
    id = generateId();
  }

  return id;
}

export function formatTime24hrsOr12hrs (time, format) {
  if (format === '24hrs') {
      // Convert to 24-hour format (e.g., 1:00 PM -> 13:00)
      return moment(time, 'h:mm A').format('HH:mm');
  } else {
      // If 12-hour format, return as is (e.g., 1:00 PM -> 1:00 PM)
      return time;
  }
}

export function formatTimestamp (timestamp) {
  return moment.unix(timestamp).utc().format("DD MMM YYYY");
};

export function packageAccess(id) {
  const TRIAL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? "prod_SoFkXIV3TK8yY1" : process.env.REACT_APP_CUSTOM_ENV === "dev" ? "prod_Sk8QqRuvoQLkQK" : "prod_Sk8YQ7MHqCIMSV"
  const STANDARD = process.env.REACT_APP_CUSTOM_ENV === "prod" ? "prod_SoFmdavyFm07un" : process.env.REACT_APP_CUSTOM_ENV === "dev" ? "prod_RiCM1rhYIIwXCf" : "prod_SbH0dvwZbMnfHN"
  const PLUS = process.env.REACT_APP_CUSTOM_ENV === "prod" ? "prod_SoFvvpamskLVDJ" : process.env.REACT_APP_CUSTOM_ENV === "dev" ?  "prod_RiCOkZVazAzfq3": "prod_SbH3S8VptWZrtn"
  const PROFESSIONAL = process.env.REACT_APP_CUSTOM_ENV === "prod" ? "prod_SoG1sJnI8DKM6A" : process.env.REACT_APP_CUSTOM_ENV === "dev" ?  "prod_RiCPIEVnfmOVDP" : "prod_SbH62erJZJDhrj"
  const USER = "prod_RvDCcqf57eCBxS";

  const userLimits = {
    [TRIAL]: 5,
    [STANDARD]: 5,
    [PLUS]: 15,
    [PROFESSIONAL]: 25,
  };

  const storageLimits = {
    [TRIAL]: 50 * 1024 * 1024 * 1024,
    [STANDARD]: 50 * 1024 * 1024 * 1024,
    [PLUS]: 100 * 1024 * 1024 * 1024,
    [PROFESSIONAL]: 200 * 1024 * 1024 * 1024,
  };

  const accessMap = {
    [STANDARD]: [
      "LOGIN", "REGISTER", "FORGOT_PASSWORD", "UPDATE_PASSWORD", "DASHBOARD", "PROFILE", "APPOINTMENTS", "CRT_APPT", "MNG_APPT",
      "ADMIN", "CRT_ADMIN", "MNG_ADMIN", "CLIENTS", "CRT_CLIENT", "MNG_CLIENT", "CLIENT_SUMMARY", "INVOICE", "CRT_INVOICE", "MNG_INVOICE", "EMPLOYEE",
      "CRT_EMPLOYEE", "MNG_EMPLOYEE", "MNG_GROUPS", "INACT_EMPLOYEE", "NOTIFICATION", "CRT_NOTIFICATION",
      "MNG_NOTIFICATION", "ALERTS", "ALL_ALERTS", "CLIENT_ALERTS", "EMP_ALERTS", "SYSTEM_ALERTS", "REPORTS", 
      "REPT_CLIENTS", "REPT_EMPLOYEE", "REPT_SHIFT", "REPT_WORKSITE", "REPT_TASK", "REPT_EMAILS",
      "REPT_ACTIVITY", "REPT_TIMESHEET", "REPT_CHECKINOUT",, "MESSAGE_BOARD", "LIVE_CHAT", "CRT_CHANNELS",
      "MNG_CHANNELS", "ACCOUNTS", "SETTINGS", "BILLING", "UPGRADE", "SUPPORT", "CREATE_SUPPORT", "DETAILS_SUPPORT", "APPT_SETTINGS", 
      "NOTIFICATION_SETTINGS", "CLIENTS_SETTINGS", "COMPNAY_SUBSCRIPTION", "TECHNICAL_SUPPORT", "MANAGE_SUPPORT", "ARCHIVE_SUPPORT", "ARCHIVEDETAILS_SUPPORT", "VERIFY_EMAIL", "VERIFY"
    ],

    [PLUS]: [
      "LOGIN", "REGISTER", "FORGOT_PASSWORD", "UPDATE_PASSWORD", "DASHBOARD", "PROFILE", "APPOINTMENTS", "CRT_APPT", "MNG_APPT",
      "ADMIN", "CRT_ADMIN", "MNG_ADMIN", "CLIENTS", "CRT_CLIENT", "MNG_CLIENT", "CLIENT_SUMMARY", "INVOICE", "CRT_INVOICE", "MNG_INVOICE", "EMPLOYEE",
      "CRT_EMPLOYEE", "MNG_EMPLOYEE", "MNG_GROUPS", "INACT_EMPLOYEE", "NOTIFICATION", "CRT_NOTIFICATION",
      "MNG_NOTIFICATION", "ALERTS", "ALL_ALERTS", "CLIENT_ALERTS", "EMP_ALERTS", "SYSTEM_ALERTS", "REPORTS", "REPT_CLIENTS", "REPT_EMPLOYEE",
      "REPT_SHIFT", "REPT_WORKSITE", "REPT_TASK", "REPT_EMAILS",
      "REPT_ACTIVITY", "REPT_TIMESHEET", "REPT_CHECKINOUT", "MESSAGE_BOARD", "LIVE_CHAT", "CRT_CHANNELS",
      "MNG_CHANNELS", "ACCOUNTS", "SETTINGS", "BILLING", "UPGRADE", "SUPPORT", "CREATE_SUPPORT", "DETAILS_SUPPORT", "APPT_SETTINGS", 
      "NOTIFICATION_SETTINGS", "CLIENTS_SETTINGS", "COMPNAY_SUBSCRIPTION", "SMS_NOTIFICATION", "CHAT_MEDIA", "TECHNICAL_SUPPORT", "MANAGE_SUPPORT", "ARCHIVE_SUPPORT", "ARCHIVEDETAILS_SUPPORT", "VERIFY_EMAIL", "VERIFY"
    ],

    [PROFESSIONAL]: [
      "LOGIN", "REGISTER", "FORGOT_PASSWORD", "UPDATE_PASSWORD", "DASHBOARD", "PROFILE", "APPOINTMENTS", "CRT_APPT", "MNG_APPT",
      "ADMIN", "CRT_ADMIN", "MNG_ADMIN", "CLIENTS", "CRT_CLIENT", "MNG_CLIENT", "CLIENT_SUMMARY", "INVOICE", "CRT_INVOICE", "MNG_INVOICE", "EMPLOYEE",
      "CRT_EMPLOYEE", "MNG_EMPLOYEE", "MNG_GROUPS", "INACT_EMPLOYEE", "NOTIFICATION", "CRT_NOTIFICATION",
      "MNG_NOTIFICATION", "ALERTS", "ALL_ALERTS", "CLIENT_ALERTS", "EMP_ALERTS", "SUPPLIES_ALERTS",
      "ISSUES_ALERTS", "SYSTEM_ALERTS", "SUPPLIES", "MNG_SUPPLIES", "ARCH_SUPPLIES",
      "ISSUES", "MNG_ISSUES", "ARCH_ISSUES", "REPORTS", "REPT_CLIENTS", "REPT_EMPLOYEE",
      "REPT_SHIFT", "REPT_WORKSITE", "REPT_TASK", "REPT_ISSUES", "REPT_EMAILS",
      "REPT_ACTIVITY", "REPT_TIMESHEET", "REPT_CHECKINOUT", "REPT_SUPPLIES", "MESSAGE_BOARD", "LIVE_CHAT", "CRT_CHANNELS",
      "MNG_CHANNELS", "ACCOUNTS", "SETTINGS", "BILLING", "UPGRADE", "SUPPORT", "CREATE_SUPPORT", "CONTACTUS", "TECHNICAL_SUPPORT", "MANAGE_SUPPORT", "APPT_SETTINGS", "NOTIFICATION_SETTINGS", "SUPPLY_SETTINGS",
      "ISSUES_SETTINGS", "CLIENTS_SETTINGS", "COMPNAY_SUBSCRIPTION", "SMS_NOTIFICATION", "CHAT_MEDIA", "DETAILS_SUPPORT", "ARCHIVE_SUPPORT", "ARCHIVEDETAILS_SUPPORT", "VERIFY_EMAIL", "VERIFY"
    ],

    [USER]: [
      "LOGIN", "REGISTER", "FORGOT_PASSWORD", "UPDATE_PASSWORD", "DASHBOARD", "PROFILE", "APPOINTMENTS", "CRT_APPT", "MNG_APPT",
      "ADMIN", "CRT_ADMIN", "MNG_ADMIN", "CLIENTS", "CRT_CLIENT", "MNG_CLIENT", "CLIENT_SUMMARY", "INVOICE", "CRT_INVOICE", "MNG_INVOICE", "EMPLOYEE",
      "CRT_EMPLOYEE", "MNG_EMPLOYEE", "MNG_GROUPS", "INACT_EMPLOYEE", "NOTIFICATION", "CRT_NOTIFICATION",
      "MNG_NOTIFICATION", "ALERTS", "ALL_ALERTS", "CLIENT_ALERTS", "EMP_ALERTS", "SYSTEM_ALERTS", "REPORTS", 
      "REPT_CLIENTS", "REPT_EMPLOYEE", "REPT_SHIFT", "REPT_WORKSITE", "REPT_TASK", "REPT_EMAILS",
      "REPT_ACTIVITY", "REPT_TIMESHEET", "REPT_CHECKINOUT",, "MESSAGE_BOARD", "LIVE_CHAT", "CRT_CHANNELS",
      "MNG_CHANNELS", "ACCOUNTS", "SETTINGS", "BILLING", "UPGRADE", "SUPPORT", "CREATE_SUPPORT", "DETAILS_SUPPORT", 
      "APPT_SETTINGS", "NOTIFICATION_SETTINGS", "CLIENTS_SETTINGS", "COMPNAY_SUBSCRIPTION", "TECHNICAL_SUPPORT", "MANAGE_SUPPORT", "ARCHIVE_SUPPORT", "ARCHIVEDETAILS_SUPPORT", "VERIFY_EMAIL", "VERIFY"]
  };

  return {
    routes: accessMap[id] || [],
    userLimit: userLimits[id] || 0,
    storageLimits: storageLimits[id] || 0
  };
};
